
import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useNavigate } from 'react-router-dom';

export const LoginForm = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    const success = await login(email, password);
  
    if (success) {
      navigate('/');
    }
    
    setIsSubmitting(false);
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50">
      <Card className="w-full max-w-md shadow-lg">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl font-bold text-center">Sign In</CardTitle>
          <CardDescription className="text-center">
            Enter your email and password to access your account
          </CardDescription>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="name@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="text-sm text-blue-600 hover:text-blue-800 text-right">
              <a href="#" className="hover:underline">
                Forgot password?
              </a>
            </div>
          </CardContent>
          <CardFooter>
            <Button 
              type="submit" 
              className="w-full bg-payroll-primary hover:bg-blue-700"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Signing in...' : 'Sign In'}
            </Button>
          </CardFooter>
        </form>
        {/* <div className="p-4 text-center text-sm text-gray-500">
          <p>Demo accounts:</p>
          <div className="grid grid-cols-2 gap-2 mt-2 text-xs">
            <div className="border rounded p-2">
              <p className="font-semibold">Admin</p>
              <p>admin@example.com</p>
            </div>
            <div className="border rounded p-2">
              <p className="font-semibold">HR</p>
              <p>hr@example.com</p>
            </div>
            <div className="border rounded p-2">
              <p className="font-semibold">Finance</p>
              <p>finance@example.com</p>
            </div>
            <div className="border rounded p-2">
              <p className="font-semibold">Employee</p>
              <p>jane@example.com</p>
            </div>
          </div>
          <p className="mt-2">Use any password to login</p>
        </div> */}
      </Card>
    </div>
  );
};
